// ⇘⇘⇘⇘⇘⇘⇘   ⇓ ⇓ ⇓ ⇓ ⇓  ⇙⇙⇙⇙⇙⇙⇙⇙
// ⇒ ⇒ ⇒ ⇒ ⇒ *R*E*A*C*T* ⇐ ⇐ ⇐ ⇐
// ⇗⇗⇗⇗⇗⇗⇗   ⇑ ⇑ ⇑ ⇑ ⇑  ⇖⇖⇖⇖⇖⇖⇖⇖

import React, { useState } from 'react';

import { Card, Form, Button, Spinner } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

import { updateDato } from '../funzioni';

const Modifica = ({ descrizione, tipo, valore, modificabile, idDato, formatoData }) => {
  const states = {
    LOADING: 'loading',
    ACTIVE: 'active',
    DISABLED: 'disabled',
    SAVE: 'save',
  };

  const [buttonState, setButtonState] = useState(modificabile ? states.ACTIVE : states.DISABLED);
  const [modifica, setModifica] = useState(false);
  const [valoreInput, setValoreInput] = useState(
    formatoData && valore
      ? valore
          .split('/')
          .reverse()
          .map((i, inn) => (i.length < 2 ? `0${i}` : i)) // metto uno 0 prima del mese se è a una cifra (gennaio) 1 => 01
          .join('-')
      : valore
  );

  const handleButtonClick = () => {
    switch (buttonState) {
      case states.ACTIVE:
        setModifica(true);
        setButtonState(states.SAVE);
        break;

      case states.SAVE:
        setModifica(false);
        updateDato(
          idDato,
          formatoData ? new Date(valoreInput).toLocaleDateString('it-It', { day: '2-digit', month: '2-digit', year: 'numeric' }) : valoreInput,
          'dato'
        );
        break;
      default:
        break;
    }
  };

  const getIcon = () => {
    switch (buttonState) {
      case states.ACTIVE:
        return 'edit';
      case states.DISABLED:
        return 'edit';
      case states.SAVE:
        return 'save';
      default:
        return '';
    }
  };

  return (
    <Card border className="border-primary h-100">
      <Card.Header className="p-3">
        <Card.Title className="m-0">{descrizione}</Card.Title>
      </Card.Header>
      <Card.Body>
        <div className="d-flex">
          <Form.Control
            type={tipo}
            value={valoreInput}
            onChange={(e) => {
              setValoreInput(e.target.value);
            }}
            maxLength={tipo === 'text' ? 100 : null}
            disabled={!modifica}
          />
          <Button className="ms-3" disabled={buttonState === states.DISABLED} onClick={handleButtonClick}>
            {buttonState === states.LOADING ? <Spinner animation="border" size="sm" /> : <CsLineIcons icon={getIcon()} />}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Modifica;
